import { Box } from 'rebass/styled-components'

export default (props) => <Box height="6px" bg="#eee" {...props} />
